import * as Sentry from '@sentry/react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Page } from 'components/Page';
import { Button } from 'components/general/Button';

import { trackError } from 'utils/analytics';
import { Logger } from 'utils/logger';

import { Topbar } from 'layout/Topbar';

export default function RuntimeError({ error }: { error: any }) {
  const navigate = useNavigate();
  const { t } = useTranslation('run-time');

  // NB: This log is intentionally kept in code, in case an end
  // user needs to open Dev Tools to report it to support
  Logger.error(error);
  trackError({ error });
  Sentry.captureException(error);
  return (
    <Page title="Unexpected Error" description="Unexpected Error">
      <Topbar />
      <div className="flex flex-col items-center justify-center h-[calc(100vh-64px)] text-center p-8">
        <Typography.Title level={3}>{t('unexpected-error')}</Typography.Title>
        <span>{t('error-contact-support')}</span>
        <Button onClick={() => navigate('/')} className="mt-4">
          {t('return-to-home')}
        </Button>
      </div>
    </Page>
  );
}
